import PeriodDataStore from '../../datastores/PeriodDataStore';

export default class PeriodDataStoreMock implements PeriodDataStore {
  async getCurrentPeriod() {
    const data = {
      period: {
        id: '2242',
        description: '2024 - Ciclo 1 Marzo',
        shortDescription: '2024-2',
        startDate: 1616371200000,
        endDate: 1627171200000,
        weeks: [
          {
            id: 1,
            desc: 'Semana 1',
            start: 1616371200000,
            end: 1616975999999
          },
          {
            id: 2,
            desc: 'Semana 2',
            start: 1616976000000,
            end: 1617580799999
          },
          {
            id: 3,
            desc: 'Semana 3',
            start: 1617580800000,
            end: 1618185599999
          },
          {
            id: 4,
            desc: 'Semana 4',
            start: 1618185600000,
            end: 1618790399999
          },
          {
            id: 5,
            desc: 'Semana 5',
            start: 1618790400000,
            end: 1619395199999
          },
          {
            id: 6,
            desc: 'Semana 6',
            start: 1619395200000,
            end: 1619999999999
          },
          {
            id: 7,
            desc: 'Semana 7',
            start: 1620000000000,
            end: 1620604799999
          },
          {
            id: 8,
            desc: 'Semana 8',
            start: 1620604800000,
            end: 1621209599999
          },
          {
            id: 9,
            desc: 'Semana 9',
            start: 1621209600000,
            end: 1621814399999
          },
          {
            id: 10,
            desc: 'Semana 10',
            start: 1621814400000,
            end: 1622419199999
          },
          {
            id: 11,
            desc: 'Semana 11',
            start: 1622419200000,
            end: 1623023999999
          },
          {
            id: 12,
            desc: 'Semana 12',
            start: 1623024000000,
            end: 1623628799999
          },
          {
            id: 13,
            desc: 'Semana 13',
            start: 1623628800000,
            end: 1624233599999
          },
          {
            id: 14,
            desc: 'Semana 14',
            start: 1624233600000,
            end: 1624838399999
          },
          {
            id: 15,
            desc: 'Semana 15',
            start: 1624838400000,
            end: 1625443199999
          },
          {
            id: 16,
            desc: 'Semana 16',
            start: 1625443200000,
            end: 1626047999999
          },
          {
            id: 17,
            desc: 'Semana 17',
            start: 1626048000000,
            end: 1626652799999
          },
          {
            id: 18,
            desc: 'Semana 18',
            start: 1626652800000,
            end: 1627171200000
          }
        ],
        modules: [
          {
            career: 'PPE',
            code: 'M02',
            name: 'MODULO 2',
            startDate: 1621814400000,
            endDate: 1626566400000,
            __typename: 'StudentModule'
          },
          {
            career: 'PPE',
            code: 'M01',
            name: 'MODULO 1',
            startDate: 1616371200000,
            endDate: 1621728000000,
            __typename: 'StudentModule'
          },
          {
            career: 'PPE',
            code: 'M03',
            name: 'BIMODULAR',
            startDate: 1616371200000,
            endDate: 1626566400000,
            __typename: 'StudentModule'
          },
          {
            career: 'PREG',
            code: '001',
            name: 'INICIO 001',
            startDate: 1616371200000,
            endDate: 1626566400000,
            __typename: 'StudentModule'
          }
        ]
      }
    };
    return data.period;
  }
}
